module.exports = __webpack_public_path__ + "static/media/key-area-2.c00c17df.png";